type PartnerName = {
	name: string;
	middleName?: string | null;
	surname: string;
};

export type PartnerNameOrder = "given-first" | "surname-first";

export const formatPartnerName = (
	partner: PartnerName,
	nameOrder: PartnerNameOrder = "given-first",
): string => {
	const givenNames = [partner.name, partner.middleName].filter(Boolean);
	const nameParts =
		nameOrder === "surname-first"
			? [partner.surname, ...givenNames]
			: [...givenNames, partner.surname];

	return nameParts.join(" ");
};
